import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { SelectionPanel } from "@/components/master-catalog/SelectionPanel";

export default function MasterCatalogLinkView() {
  const { id } = useParams();
  const [sel, setSel] = useState(null);
  const load = () => api.get(`/master-catalog/links/${id}/selection`).then((r) => setSel(r.data));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const exportFile = async (fmt) => {
    try {
      const r = await api.get(`/master-catalog/links/${id}/export.${fmt}`, {
        params: { revision: sel.revision, rate_version: sel.versions.rate_version }, responseType: "blob" });
      const href = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = href;
      a.download = `MasterCatalog_${sel.link.name}.${fmt}`;
      a.click();
      URL.revokeObjectURL(href);
    } catch (e) {
      if (e.response?.status === 409) { toast.error("Selection or prices changed — refreshed, download again"); load(); }
      else toast.error("Download failed");
    }
  };
  return (
    <div className="space-y-5" data-testid="mc-link-view">
      <Link to="/master-catalog" className="text-xs text-slate-500 flex items-center gap-1" data-testid="mc-link-view-back"><ArrowLeft className="w-3.5 h-3.5" /> Master Catalog</Link>
      <SelectionPanel sel={sel} readOnly onExport={exportFile} />
    </div>
  );
}
